<template>
<span class="alert_message">
          <v-snackbar
            v-model="alert.snack.show"
            :bottom="null === 'bottom'"
            :left="'right' === 'left'"
            
            :right="'right' === 'right'"
            :timeout="alert.snack.time"
            :top="null === 'top'"
            :vertical="'' === 'vertical'"
            id="snack"
            :class=" this.alert.snack.multiple ? 'snack_multiple' : ''"
            :color="alert.snack.color"
        >
            <strong>{{ this.alert.snack.text }}</strong>
            <v-btn
            :color="alert.snack.btnFColor"
            flat
            @click="alert.snack.show = false"
            >
            Fechar
            </v-btn>
        </v-snackbar>
</span>
<!-- alert.snack.time -->
</template>

<script>
export default {
props: ['alert'],
  data: () => ({
   
  }),
  watch: {},
  mounted: function() {
    this.$nextTick(function() {});
  }
};
</script>
<style scoped>
.lista-colunas {
  width: 46%;
  margin: 0 2% 0 0;
}
.lista-colunas ul {
  height: 40vh;
  list-style-type: none;
  overflow: auto;
}
#colItensAtivas i {
  transform: rotateY(180deg);
}
#btn_consultaAvulsa {
  background-color: #e8e8e8 !important;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/alertMessage/AlertMessage.vue